export const styles = () => ({
  taxYear: {
    color: 'rgba(0, 0, 0, 0.6)',
    marginTop: '0.15rem',
  },
  noticeTitle: {
    fontWeight: 600,
    marginBottom: '0.75rem',
  },
  noticeBody: {
    whiteSpace: 'pre-wrap',
    lineHeight: 1.6,
  },
  requiredNote: {
    display: 'block',
    marginTop: '1rem',
    fontStyle: 'italic',
  },
  checkboxLabel: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1rem',
  },
  checkBoxOutlineBlankIcon: {
    fontSize: 24,
    color: '#8FC3FF',
  },
  checkBoxIcon: {
    fontSize: 24,
  },
});
